import { Space, Tag } from 'antd';
import { useCallback, useMemo } from 'react';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import {
  HAS_RECORDS_RADIO_OPTIONS,
  PF,
} from '@pages/Clients/NewClientsList/data/constants';
export const HasRecordsSelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangeHasRecords } = useNewClientsListContext();

  const { hasRecords } = filtersMap.get(id)!;

  const selected = hasRecords !== null && hasRecords !== undefined;

  const tagLabel = useMemo(() => {
    return HAS_RECORDS_RADIO_OPTIONS.find(
      (option) => option.value === hasRecords
    )?.label;
  }, [hasRecords]);

  const onClose = useCallback(() => {
    onChangeHasRecords(null, id);
  }, [onChangeHasRecords, id]);

  if (!selected) {
    return null;
  }

  return (
    <Space className={`${PF}__tags`}>
      <Tag className={`${PF}__tag`} closable onClose={onClose}>
        {tagLabel}
      </Tag>
    </Space>
  );
};
